import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services';
import { ApiService } from 'src/app/api.service';
import { AssistDt1 } from 'src/app/shared/models/AssistDt1';
import { AssistHdr } from 'src/app/shared/models/AssistHdr';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { Item } from 'src/app/shared/models/Item';
import { ItemsAlbum } from 'src/app/shared/models/ItemsAlbum';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';

@Component({
  selector: 'app-guidelines-assist-dt1',
  templateUrl: './guidelines-assist-dt1.component.html',
  styleUrls: ['./guidelines-assist-dt1.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class GuidelinesAssistDt1Component implements OnInit {

  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};

  /** LABELS */
  translations: Record<string, string> = {};

  /** COMPONENT */
  lstItemsAlbum: AssistDt1[];
  selectedAlbum: AssistDt1;
  itemId: string;
  token: string;
  security: SecurityDocument;
  item: AssistHdr = null;
  albumId: string;

  name: string;
  itemDialog: boolean;
  showInternatColumns: boolean;

  /**
   * The constructor initializes various services and properties, retrieves query parameters from the
   * route, and performs authentication based on user preferences.
   * @param {MessageService} messageService - The `messageService` parameter is used to handle
   * messaging within the application, such as displaying notifications or alerts to the user. It is
   * likely a service that provides methods for showing messages to the user interface.
   * @param {ConfirmationService} confirmationService - The `confirmationService` parameter in the
   * constructor is likely a service that provides functionality related to displaying confirmation
   * dialogs or messages to the user. This service may be used to prompt the user for confirmation
   * before proceeding with certain actions in the application. It could handle displaying pop-up
   * dialogs with options for the user to
   * @param {ApiService} apiService - The `apiService` parameter in the constructor is likely a service
   * that handles API calls in your application. It could be responsible for making HTTP requests to
   * your backend server, handling responses, and managing data communication between your frontend and
   * backend systems. This service is essential for interacting with external APIs or your own
   * @param {DatePipe} datepipe - The `DatePipe` is a built-in Angular pipe that is used for formatting
   * dates in templates. It provides various date formats and options for displaying dates in a
   * user-friendly way. You can use it to format dates in your Angular application based on the user's
   * locale or specific format requirements.
   * @param {ActivatedRoute} route - The `route` parameter in the constructor is of type
   * `ActivatedRoute`, which is a service provided by Angular that gives access to information about a
   * route associated with a component that is loaded in an outlet. It allows you to access route
   * parameters, query parameters, and other information related to the current route
   * @param {Router} router - The `router` parameter in the constructor is an instance of the Angular
   * Router service. It provides navigation and URL manipulation capabilities in your Angular
   * application. With the `router`, you can navigate between different components, pass parameters in
   * the URL, and handle route changes within your application.
   * @param {AuthenticationService} authenticationService - The `authenticationService` parameter in
   * the constructor is a service that handles authentication-related functionalities in the
   * application. It is used for user authentication, authorization, and managing user sessions. This
   * service likely provides methods for logging in, logging out, checking user permissions, and other
   * authentication-related tasks.
   * @param {UserPreferencesService} userPreferencesService - The `userPreferencesService` parameter in
   * the constructor is a service that is responsible for managing and storing user preferences within
   * the application. It likely provides functionality for saving, retrieving, and updating
   * user-specific settings such as language preferences, theme preferences, notification settings, and
   * more. This service helps in providing a
   * @param {TovpilLanguageService} translationService - The `translationService` parameter in the
   * constructor is an instance of `TovpilLanguageService`. It is used for handling language
   * translation within the application. This service likely provides methods and functionality related
   * to translating text or content into different languages based on user preferences or settings.
   * @param {TovpilUtilsService} tovpilUtils - The `tovpilUtils` parameter in the constructor is an
   * instance of the `TovpilUtilsService` service. This service likely provides utility functions and
   * methods that are used within the component or service where it is injected. It may contain helper
   * functions for common tasks, data manipulation,
   */
  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private userPreferencesService: UserPreferencesService,
    private translationService: TovpilLanguageService,
    private tovpilUtils: TovpilUtilsService

  ) { 
    this.initConfigs();
    this.route.queryParams.subscribe((params) => {
      this.itemId = params.itemId;
      this.token = params.token;
    });

    // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
    const user = this.globalUserPreferences.preferences;
    const securitySelected = this.globalUserPreferences;

    if (securitySelected?.tokenProfile && user && user.device === "2") {
      this.autenthicateByZuul("generalaccess", "hY6Mn_4hn9vDrWrh6");
    } else {
      //this.globalUserPreferences.preferences.currentUser = currentUser;
    }
  }

   /**
   * The function initializes form groups for configuration and data, and updates the configuration form
   * with query parameters from the route.
   */
   async initConfigs() {
    // CONSULTAMOS COOKIES
    this.globalUserPreferences =
      (await this.userPreferencesService.getSantovTovpilCookie()) || null;
    console.debug(
      "guideLinesAssistDT1 - USER PREFERENCES: " +
        JSON.stringify(this.globalUserPreferences, null, 2)
    );
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService
      .login(user, password)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data.code == "R-0200") {
            this.getSecurity();
          } else {
            // this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
          }
        },
        (error) => {
          //this.messageService.add({ severity: 'warn', summary: 'Autenticación', detail: 'Se presentó una intermitencia en la autenticación, intentelo mas tarde' });
        }
      );
  }

  /**
   * The ngOnInit function calls the getSecurity method when the component is initialized.
   */
  ngOnInit(): void {
    this.showInternatColumns = false;
    this.getSecurity();
  }

   /**
   * The function `getSecurity` asynchronously retrieves security data using an API service, then
   * proceeds to fetch translated labels, a guide, and an item list if the security data is
   * successfully obtained.
   */
   async getSecurity() {
    const securityControl = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (!securityControl) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences = data;
    }

    if (securityControl.preferences.levelId == 'I') {
      this.showInternatColumns = true;
    }
    await this.getTranslatedLabels();
    await this.getItemById();
    await this.lstItmsAlbByItemLanguage();
    this.blocked = false;
  }


 /**
  * This TypeScript function asynchronously retrieves a list of items in an album based on the item's
  * language.
  */
  async lstItmsAlbByItemLanguage() {
    try{
      const language = this.globalUserPreferences.preferences.language || null;
      this.lstItemsAlbum = null;
      const data = await this.apiService.getAssistDt1ByAssistId({
      "assistId": this.itemId,
      "language": language
    });  
    this.lstItemsAlbum = data;
    }catch(error){
      console.debug("Error en lstItmsByItemLanguage");
    }
  }


  /**
   * The function `getItemById` asynchronously retrieves an item by its ID using the `apiService` with
   * language preferences taken into account.
   */
  async getItemById() {
    const language = this.globalUserPreferences.preferences.language || null;
    const data = await this.apiService.getAssistHdrById(
      {
        "assistId": this.itemId,
        "language": language
      });    
        this.item = data;
  }


  /**
   * The `selectRecord` function navigates to a specific route with query parameters in a TypeScript
   * application.
   * @param {string} albumId - The `albumId` parameter is a string that represents the unique
   * identifier of an album. It is used as a parameter in the `selectRecord` method to navigate to a
   * specific route in the application.
   */
  selectRecord(albumId: string) {
    this.router.navigate(['commons/guideLinesAssistDt2'], { queryParams: { itemId: this.itemId, albumId: albumId, token: this.token } });
  }


  /**
   * The function `getTranslatedLabels` asynchronously retrieves translated labels based on user
   * preferences and handles any errors that occur.
   */
  async getTranslatedLabels() {
    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
    } catch (error) {
      console.error(
        "An error occurred while getting translated labels:",
        error
      );
      // this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}` });
    }
  }

  /**
   * The `goBack` function closes the current window.
   */
  goBack() {
    this.router.navigate(['commons/guideLinesAssist'], { queryParams: { token: this.token } });
  }
}
